import React, { useState, useEffect } from 'react';
import './crumblePlus.css'; // External CSS for styling and animations
//import WORDS from './wordBank.js';
import { LightBulbIcon } from '@heroicons/react/24/solid';
import { Bars3Icon } from '@heroicons/react/24/solid';

import PocketBase from 'pocketbase';

import ufLogo from './UF_logo.png';
import bannerLogo from './crumblePlus_animations/crumblePlusLogo_1.gif';

import CrumbleVault from './crumbleVault';
import Mines from './Mines';

function CrumblePlus({ wordDate, wordIndex }) {
  const [showCrumbleVault, setShowCrumbleVault] = useState(false);
  const [showMines, setShowMines] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [darkMode, setDarkMode] = useState(() => {
    const saved = localStorage.getItem('cpDarkMode');
    return saved ? JSON.parse(saved) : false;
  });
  const [showInfoPopup, setShowInfoPopup] = useState(false);
  const [leaderboard, setLeaderboard] = useState([]);

  useEffect(() => {
    const pb = new PocketBase('https://api.vanishing.play-it.me/');
    pb.collection('users').getFullList({
      sort: '-streak',
      fields: 'id,name,streak', // <-- Add 'id' here
    }).then(result => {
      setLeaderboard(result);
    }).catch(() => {
      setLeaderboard([]);
    });
  }, []);

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add('dark-mode');
      document.documentElement.classList.add('dark-mode');
    } else {
      document.body.classList.remove('dark-mode');
      document.documentElement.classList.remove('dark-mode');
    }
  }, [darkMode]);

  return (
    <>
      <div className="cp-leaderboard">
        <h2>Leaderboard</h2>
        <div className="cp-podium">
          {/* 2nd Place */}
          {leaderboard[1] && (
            <div className="cp-podium-place cp-podium-second">
              <div className="cp-podium-rank">2</div>
              <div className="cp-podium-name">{leaderboard[1].name}</div>
              <div className="cp-podium-streak">Streak: {leaderboard[1].streak}</div>
            </div>
          )}
          {/* 1st Place */}
          {leaderboard[0] && (
            <div className="cp-podium-place cp-podium-first">
              <div className="cp-podium-rank">1</div>
              <div className="cp-podium-name">{leaderboard[0].name}</div>
              <div className="cp-podium-streak">Streak: {leaderboard[0].streak}</div>
            </div>
          )}
          {/* 3rd Place */}
          {leaderboard[2] && (
            <div className="cp-podium-place cp-podium-third">
              <div className="cp-podium-rank">3</div>
              <div className="cp-podium-name">{leaderboard[2].name}</div>
              <div className="cp-podium-streak">Streak: {leaderboard[2].streak}</div>
            </div>
          )}
        </div>
        {/* Mini Leaderboard: Top 10 */}
        <div className="cp-mini-leaderboard">
          <h3>Top 10 Players</h3>
          <table>
            <thead>
              <tr>
                <th>Rank</th>
                <th>Name</th>
                <th>Streak</th>
              </tr>
            </thead>
            <tbody>
              {leaderboard.slice(0, 10).map((player, idx) => (
                <tr key={player.id} className={idx < 3 ? 'cp-podium-row' : ''}>
                  <td>{idx + 1}</td>
                  <td>{player.name}</td>
                  <td>{player.streak}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {/* End Mini Leaderboard */}
      </div>
      <div className="cp-main-content">
        {!showCrumbleVault && !showMines && (
          <>
            <div className="cp-toolbar">
              <div className="cp-date"></div>
              <div className="cp-title">
                <img src={bannerLogo} alt="Logo" />
              </div>
              <button
                className="cp-toolbar-hamburger"
                onClick={() => setShowMobileMenu((open) => !open)}
                aria-label="Menu"
              >
                <Bars3Icon style={{ width: 32, height: 32, verticalAlign: 'middle' }} />
              </button>
              <div className="cp-toolbar-buttons">
                <button
                  onClick={() => setShowInfoPopup(true)}
                  className="cp-toolbar-button"
                  title="About Us"
                >
                  <img src={ufLogo} alt="UF Logo" style={{ width: 32, height: 32, verticalAlign: 'middle', borderRadius: '6px' }} />
                </button>
                <button
                  onClick={() => {
                    setDarkMode((prev) => {
                      localStorage.setItem('cpDarkMode', JSON.stringify(!prev));
                      return !prev;
                    });
                  }}
                  className="cp-toolbar-button"
                  title="Color Scheme"
                >
                  <LightBulbIcon style={{ width: 32, height: 32, verticalAlign: 'middle' }} />
                </button>
              </div>
              {/* Mobile dropdown */}
              {showMobileMenu && (
                <div className="cp-mobile-menu">
                  <button
                    onClick={() => { setShowInfoPopup(true); setShowMobileMenu(false); }}
                    className="cp-toolbar-button"
                    title="Info"
                  >
                    <img src={ufLogo} alt="UF Logo" style={{ width: 32, height: 32, verticalAlign: 'middle', borderRadius: '6px' }} />
                    Info
                  </button>
                  <button
                    onClick={() => {
                      setDarkMode((prev) => {
                        localStorage.setItem('cpDarkMode', JSON.stringify(!prev));
                        return !prev;
                      });
                      setShowMobileMenu(false);
                    }}
                    className="cp-toolbar-button"
                    title="Light/Dark Mode"
                  >
                    <LightBulbIcon style={{ width: 32, height: 32, verticalAlign: 'middle' }} />
                    {darkMode ? 'Light' : 'Dark'}
                  </button>
                </div>
              )}
            </div>
            <button
              onClick={() => setShowCrumbleVault(true)}
              className="cp-play-button"
              style={{ margin: '2em auto', display: 'block' }}
            >
              Crumble Vault
            </button>
            <button
              onClick={() => setShowMines(true)}
              className="cp-play-button"
              style={{ margin: '2em auto', display: 'block' }}
            >
              Mines
            </button>
            <button
              onClick={() => window.location.reload()}
              className="cp-play-button"
              style={{ margin: '2em auto', display: 'block' }}
            >
              Back to Crumble
            </button>
          </>
        )}
          {showInfoPopup && (
            <div className="vp-popup-overlay">
              <div className="vp-popup">
                <button onClick={() => setShowInfoPopup(false)} style={{right: '-460px'}} className="vp-close">X</button>
                <h2>About Unstoppable Force, The Makers of Crumble!</h2>
                <p>Unstoppable Force is a bold leadership and personal growth movement built to help people like you level up in real life—not just in-game. </p>
                <p>We turn mental resilience, team connection, and self-leadership into your ultimate power-ups. </p>
                <p>If you’re ready to live beyond your limits, you’re in the right place.</p>
                <p> Visit <a href="https://unstoppableforce.co.nz">our website</a> for more information!</p>
                <button onClick={() => setShowInfoPopup(false)} className="vp-play-button">Back to the game!</button>
              </div>
            </div>
          )}
        {showCrumbleVault ? (
          <CrumbleVault />
        ) : showMines ? (
          <Mines />
        ) : null}
      </div>
    </>
  );
}

export default CrumblePlus;